/**
 * Low-level DXF group-value parsing primitives shared by entityParser.ts
 * and the entity-family modules extracted from it (R17
 * A12A-DXF-ENTITY-PARSER-REGISTRY-SEAM). Pure structural move — identical
 * parsing semantics and identical thrown error messages to the private
 * helpers that used to live inline in entityParser.ts.
 *
 * A dependency-free leaf: imports only from ./types, so entityParser.ts
 * and every per-family module can import FROM here without creating a
 * cycle back into entityParser.ts.
 */

import { type DxfPoint3D } from "./types";

export type MutablePoint = Partial<DxfPoint3D>;

export function getOrCreatePoint(
  collection: Record<string, MutablePoint>,
  key: string
): MutablePoint {
  const existing = collection[key];

  if (existing) {
    return existing;
  }

  const created: MutablePoint = {};
  collection[key] = created;
  return created;
}

export function setPointComponent(
  collection: Record<string, MutablePoint>,
  key: string,
  component: keyof DxfPoint3D,
  code: number,
  value: string
): void {
  getOrCreatePoint(collection, key)[component] = parseNumberGroup(code, value);
}

export function parseNumberGroup(code: number, value: string): number {
  const parsed = Number(value.trim());
  if (!Number.isFinite(parsed)) {
    throw new Error(`Group ${code} expected a finite number, received "${value}"`);
  }
  return parsed;
}
